import { NgModule } from '@angular/core';

import { FilterPipe, LIB_CommonModule, SearchPipe, SorterPipe } from 'pbc.angular';

import { BerichteService } from '.';

@NgModule({
  imports: [LIB_CommonModule],
  providers: [BerichteService, SearchPipe, FilterPipe, SorterPipe],
  exports: [],
})
export class BerichteServiceModule {}
